[
  {
    "id": "SWW-B8P-L302-001",
    "module": "SpellingWW",
    "difficulty": 302,
    "difficultyTier": 14,
    "levelCode": "B8+",
    "group": 8,
    "question": "Hij ... de wedstrijd. (leiden)",
    "options": ["leidt", "leid", "leidde", "geleid"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tegenwoordige_tijd",
    "subSkill": "tt_pv_dt",
    "familyId": "SWW-TT-DT-PV",
    "conceptId": "present_tense_third_person_dt",
    "variantIndex": 1,
    "explanation": "Je zoekt de persoonsvorm in de **tegenwoordige tijd** bij hij.\n\n1) Hele werkwoord: *leiden*.\n2) Stam: leid.\n3) Bij hij/zij/het: stam + t → leidt.\nLet op: je schrijft hier geen -dt; het is gewoon Leid + t.",
    "distractorExplanations": {
      "1": "Leid is de ik-vorm: “ik leid”. Bij hij komt er een t achter: “hij leidt”.",
      "2": "Leidde is verleden tijd. In de zin staat geen ‘gisteren’ en je kiest hier tegenwoordige tijd: “Hij leidt de wedstrijd.”",
      "3": "Geleid is het voltooid deelwoord. Dat gebruik je met *heeft/is*: “Hij heeft geleid.” Hier heb je de persoonsvorm nu nodig: leidt."
    }
  },
  {
    "id": "SWW-B8P-L302-002",
    "module": "SpellingWW",
    "difficulty": 302,
    "difficultyTier": 14,
    "levelCode": "B8+",
    "group": 8,
    "question": "Hij ... aan een ziekte. (lijden = pijn hebben)",
    "options": ["lijdt", "lijd", "leidt", "leid"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tegenwoordige_tijd",
    "subSkill": "homofonen_leiden_lijden",
    "familyId": "SWW-HOMO-LEIDEN-LIJDEN",
    "conceptId": "homophones_leiden_vs_lijden",
    "variantIndex": 1,
    "explanation": "Hier bedoel je **pijn hebben/ondergaan**. Dat is *lijden* (met **ij**).\nBij **hij**: stam **lijd** + **t** → **lijdt**.\n\nEzelsbrug: *lijden* hoort bij **pijn** → allebei met **ij**.",
    "distractorExplanations": {
      "1": "**Lijd** is de ik-vorm (“ik lijd”). Bij **hij** hoort stam + t: **lijdt**.",
      "2": "**Leidt** komt van *leiden* (de weg wijzen / aanvoeren). Dat past niet bij ‘aan een ziekte’.",
      "3": "**Leid** is de ik-vorm van *leiden*. Je hebt het verkeerde werkwoord én de verkeerde persoonsvorm."
    }
  },
  {
    "id": "SWW-B8P-L302-003",
    "module": "SpellingWW",
    "difficulty": 302,
    "difficultyTier": 14,
    "levelCode": "B8+",
    "group": 8,
    "question": "De ... auto (leasen).",
    "options": ["geleaste", "geleasede", "geleasde", "geleased"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "bijvoeglijk_deelwoord",
    "subSkill": "leenwerkwoord_bnvd",
    "familyId": "SWW-LEENWW-BNVD-TEDE-OP_KLANK",
    "conceptId": "loanword_past_participle_adjective_te_rule",
    "variantIndex": 1,
    "explanation": "Je beschrijft **de auto** → bijvoeglijk gebruikt deelwoord met **-e**.\n\nBij leenwerkwoorden kijk je vaak naar de **klank** aan het eind van de stam:\n*leasen* → stam klinkt als **leas** (eindklank **s**).\nS zit in ’t kofschip → voltooid deelwoord eindigt op **-t**: **geleast**.\nDaarna bijvoeglijk: **geleast + e = geleaste**.",
    "distractorExplanations": {
      "1": "**Geleasede** lijkt op een verleden tijd (…de) en mixt Engelse spelling met Nederlandse regels. Hier heb je een bijvoeglijk gebruikt deelwoord: **geleaste auto**.",
      "2": "**Geleasde** laat de **t** weg die je nodig hebt door de eindklank **s** (’t kofschip → -t).",
      "3": "**Geleased** is ‘Engels’ geschreven en mist de Nederlandse uitgang. In het Nederlands wordt het **geleast** en bij *de auto* → **geleaste**."
    }
  },
  {
    "id": "SWW-B8P-L302-004",
    "module": "SpellingWW",
    "difficulty": 302,
    "difficultyTier": 14,
    "levelCode": "B8+",
    "group": 8,
    "question": "Het ... goud (vergulden).",
    "options": ["vergulde", "verguldde", "verguld", "verguldt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "bijvoeglijk_deelwoord",
    "subSkill": "bnvd_het_woord_met_e",
    "familyId": "SWW-BNVD-E-HET_WOORD",
    "conceptId": "adjective_past_participle_with_e",
    "variantIndex": 1,
    "explanation": "Je zegt **het goud**: dat is een **het-woord**.\nHet voltooid deelwoord van *vergulden* is **verguld**.\nAls je dat als bijvoeglijk woord gebruikt, komt er meestal **-e** achter: **het vergulde goud**.\n(Je beschrijft welk goud: verguld goud.)",
    "distractorExplanations": {
      "1": "**Verguldde** is verleden tijd (“hij verguldde …”). Hier beschrijf je *het goud* → bijvoeglijk: **vergulde**.",
      "2": "**Verguld** is het voltooid deelwoord zonder -e. In “het … goud” gebruik je het als bijvoeglijk woord, dus meestal mét **-e**: **vergulde**.",
      "3": "**Verguldt** is tegenwoordige tijd (hij verguldt). In deze zin staat geen persoonsvormplek; het woord hoort bij *goud* als beschrijving."
    }
  },
  {
    "id": "SWW-B8P-L302-005",
    "module": "SpellingWW",
    "difficulty": 302,
    "difficultyTier": 14,
    "levelCode": "B8+",
    "group": 8,
    "question": "Ik ... dat het waar is. (vermoeden)",
    "options": ["vermoed", "vermoedt", "vermoedde", "vermoeden"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tegenwoordige_tijd",
    "subSkill": "tt_ik_vorm_stam",
    "familyId": "SWW-TT-IK-VORM-STAM",
    "conceptId": "present_tense_first_person_stem",
    "variantIndex": 1,
    "explanation": "Bij **ik** in de tegenwoordige tijd gebruik je meestal alleen de **stam**.\n*Vermoeden* → stam **vermoed**.\nDus: **Ik vermoed** dat het waar is.",
    "distractorExplanations": {
      "1": "**Vermoedt** is de vorm bij **hij/zij/het** (stam + t). Bij **ik** komt er geen t achter: **vermoed**.",
      "2": "**Vermoedde** is verleden tijd (gisteren). De zin staat in het nu: “Ik vermoed …”.",
      "3": "**Vermoeden** is het hele werkwoord (infinitief). In deze zin heb je de persoonsvorm nodig: **vermoed**."
    }
  }
]
